import { useCallback, useRef } from 'react';
import { useDownloadFiles } from '@/talons';
import { useDbFunctions } from '@/talons/dbFunctions/useDBFunctions';
import { setOnStorage, invalidateCatalogCachesAfterSync } from '@/shared';

interface LoginDataSyncHook {
  syncDataOnLogin: () => Promise<boolean>;
  isSyncing: boolean;
}

export const useLoginDataSync = (): LoginDataSyncHook => {
  const { getLinks } = useDownloadFiles();
  const { reloadTables } = useDbFunctions();
  const isSyncingRef = useRef(false);

  const syncDataOnLogin = useCallback(async (): Promise<boolean> => {
    if (isSyncingRef.current) return false;

    try {
      isSyncingRef.current = true;

      const syncResult = await getLinks({ isBackground: false });

      if (syncResult) {
        setOnStorage('last_data_sync', new Date().toISOString());
        sessionStorage.setItem('data_validated_this_session', 'true');
        try {
          await reloadTables();
        } catch (err) {
          console.error('useLoginDataSync: falha ao recarregar tabelas após sync', err);
        }
        invalidateCatalogCachesAfterSync();
        return true;
      }

      return false;
    } catch (error) {
      console.error('useLoginDataSync: Erro durante sincronização:', error);
      return false;
    } finally {
      isSyncingRef.current = false;
    }
  }, [getLinks, reloadTables]);

  return {
    syncDataOnLogin,
    isSyncing: isSyncingRef.current
  };
};